<div class="input-group">
  <button
    rippleEffect
    class="btn btn-outline-primary"
    type="button"
    (click)="changeAmount(-1)"
    [disabled]="numberFormControl.disabled">
    <love-it-generic-icon selector="minus" />
  </button>
  <input
    type="number"
    id="amount"
    [formControl]="numberFormControl"
    class="form-control text-center"
    [readonly]="!manualEnter"
    [min]="min" />
  <button
    rippleEffect
    class="btn btn-outline-primary"
    type="button"
    (click)="changeAmount(1)"
    [disabled]="numberFormControl.disabled">
    <love-it-generic-icon selector="plus" />
  </button>
</div>
